import { Link } from 'react-router-dom';
import React from "react";

export const COLUMNS = [
    {
        Header: "Log ID",
        accessor: "_id",
    },
    {
        Header: "Created At",
        accessor: "created_at",
        Cell: ({ value }) => new Date(value).toLocaleString(),
    },
    {
        Header: "Program Name",
        accessor: "program_id",
        Cell: ({ row, value  }) => (
          <Link to={`/program/view/${value}`}>{row.original.program_name}</Link>
        ),
    },
    {
        Header: "V2 Program ID",
        accessor: "v2_account_holder_id",
        Cell: ({ row, value  }) => (
          <Link to={`/program/view/${row.original.program_id}`}>{value}</Link>
        ),
    },
    {
        Header: "Entrata Property Id",
        accessor: "entrata_property_id",
    },
    {
        Header: "File type",
        accessor: "file_type",
        Cell: ({ row, value }) => {
            let val = '';
            if (value === 1){
                val = 'Customers';
            } else if (value === 2) {
                val = 'Leases';
            } else if (value === 3) {
                val = 'Leads';
            } else if (value === 4) {
                val = 'Reports';
            }
            return val;
        }
    },
    {
        Header: "Response Size",
        accessor: "length",
    },
    {
        Header: "Status",
        accessor: "status",
        Cell: ({ row, value  }) => (
          <div style={{ color: value === 1 ? 'green' : 'red' }}>
              {value ? 'Success' : 'Error' }
          </div>
        ),
    },
]

